export function joinNames(allNames) {
    switch (allNames.length) {
        case 0:
            return 'None!';
        case 1:
            return allNames[0];
        case 2:
            return "".concat(allNames[0], " & ").concat(allNames[1]);
        case 3:
            return "".concat(allNames[0], ", ").concat(allNames[1], " & ").concat(allNames[2]);
        default:
            return "".concat(allNames[0], ", ").concat(allNames[1], " +").concat(allNames.length - 2);
    }
}
//# sourceMappingURL=joinNames.js.map